import { TeamOutlined } from "@ant-design/icons";
import { Empty, Select, Spin, Tag } from "antd";

const { Option } = Select;

type GroupSelectProps = {
  value: number[];
  onChange: (vals: number[]) => void;
  loading: boolean;
  options: {
    contactGroupId: number;
    name: string;
    storeCode: string;
  }[];
  filter?: number[];
};

export const GroupSelect: React.FC<GroupSelectProps> = ({
  value,
  onChange,
  loading,
  options,
  filter = [],
}) => {
  const filteredOptions = options.filter(
    (g) => !filter.includes(g.contactGroupId),
  );

  const noGroupsAvailable = options.length === 0;
  const allGroupsAssigned = options.length > 0 && filteredOptions.length === 0;

  return (
    <>
      <Select
        mode="multiple"
        placeholder="Seleccionar grupos"
        loading={loading}
        value={value}
        onChange={onChange}
        style={{ width: "100%" }}
        placement="topLeft"
        optionLabelProp="labelTag"
        notFoundContent={
          <Spin spinning={loading}>
            {noGroupsAvailable && (
              <Empty description="No hay grupos creados. Crea uno para comenzar." />
            )}
            {allGroupsAssigned && (
              <Empty description="Ya estás en todos los grupos disponibles." />
            )}
          </Spin>
        }
      >
        {filteredOptions.map((g) => (
          <Option
            key={g.contactGroupId}
            value={g.contactGroupId}
            labelTag={g.name}
          >
            <Tag icon={<TeamOutlined />} style={{ marginTop: 2 }}>
              {g.name}
            </Tag>
          </Option>
        ))}
      </Select>
    </>
  );
};
